module.exports = __webpack_public_path__ + "static/media/Philippines.183a55be.png";